"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns the negative of the given quad precision floating point number.
 * @param q low order double
 * @param Q high order double
 */
function qNegativeOf([q, Q]) {
    return [-q, -Q];
}
exports.qNegativeOf = qNegativeOf;
//# sourceMappingURL=q-negative-of.js.map